module.exports = "<div class=\"container\">\n  <div class=\"row\">\n\n    <news-post data=\"ctrl.news\" detail=\"true\" admin=\"ctrl.isAdmin()\" delete=\"ctrl.delete(post)\" type=\"ctrl.type\"></news-post>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/news/show/news-show.html
// module id = 355
// module chunks = 0